import Login from "../pages/auth/Login";
import { ResDisplay } from "../pages/monitor/ResDisplay";
import MyMail from "../pages/myMail/MyMail";
import { routeContants } from "../utils/RouteConstants";

export const PublicRoutes = [
  { path: routeContants.LOGIN, Component: <Login /> },
  { path: routeContants.MYMAIL, Component: <MyMail /> },
  { path: routeContants.RES_DISPLAY, Component: <ResDisplay /> },
  { path: routeContants.OLD_RES_DISPLAY, Component: <ResDisplay /> }
];
